import { render, staticRenderFns } from "./EventDelete.vue?vue&type=template&id=384da52e&"
import script from "./EventDelete.vue?vue&type=script&lang=js&"
export * from "./EventDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports